import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import logoLg from "../../assets/images/lg-logo.png";
import axios from "../../axios-instance";
import Loader from "../../components/Loader/Loader";

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("This verification link is invalid.");
      return;
    }

    axios
      .post("/email-verification/verify", { token })
      .then((res) => {
        setStatus("success");
        setMessage(res?.data?.message || "Your email has been verified. You can now log in.");
        setEmail(res?.data?.data?.email || "");
        setTimeout(() => navigate("/admin/login"), 2500);
      })
      .catch((err) => {
        setStatus("error");
        setMessage(
          err?.response?.data?.message || "This verification link is invalid or has expired."
        );
      });
  }, [token, navigate]);

  return (
    <div className="signup-process">
      <Loader isShowLoader={status === "loading"} />
      <div className="logo-side">
        <img src={logoLg} alt="MeetOcto" />
      </div>
      <div className="signup">
        <div className="confirm-email" style={{ textAlign: "center", padding: 40 }}>
          {status === "loading" && <h1>Verifying your email...</h1>}
          {status === "success" && (
            <>
              <h1>Email confirmed</h1>
              <p>{message}</p>
              <p style={{ color: "#888", fontSize: 14 }}>Redirecting you to login...</p>
            </>
          )}
          {status === "error" && (
            <>
              <h1>Verification failed</h1>
              <p>{message}</p>
              <div style={{ marginTop: 20, display: "flex", flexDirection: "column", gap: 12, alignItems: "center" }}>
                <Link
                  to={email ? `/confirmEmail?email=${encodeURIComponent(email)}` : "/confirmEmail"}
                  style={{ color: "#FE9920", fontWeight: 600 }}
                >
                  Request a new link
                </Link>
                <Link to="/admin/login" style={{ color: "#666" }}>
                  Back to login
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
